<template>
  <div class="as-time-line-wrap">
    <div class="flex-row-start-center" v-if="timeRes.IsShow">
      <span>商家处理时效：</span>
      <span v-if="timeRes.Status >= 23">已处理完成</span>
      <span v-else-if="timeRes.timeOut" style="color: red;">已超时</span>
      <div v-else-if="timeRes.countDownTime">
        <span style="color: red;"
          >{{ timeRes.StatusStr }} &nbsp; {{ timeRes.countDownTime }}</span
        ><span>后，即将逾期售后</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryAsTimeLine //包裹列表
} from "@/models/aftersaleModel";
import { getHMS } from "@/utils/time";

export default {
  name: "asTimeLine",
  props: ["as_number", "randomNum"],
  data() {
    return {
      timeRes: {},
      loading: false,
      timer: null
    };
  },
  watch: {
    randomNum(val) {
      // console.log("222--", val, this.as_number);
      this.timeRes = {};
      this.queryTime(this.as_number);
    }
  },
  created() {
    if (this.as_number) {
      this.queryTime(this.as_number);
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    // 获取售后单的时效
    async queryTime(as_number) {
      this.clearTimer();
      const params = {
        as_number,
        shop_id: localStorage.getItem("shop_id")
      };
      try {
        let res = await queryAsTimeLine(params);
        // res.TimeOutTime = "2023-10-17 16:07:00";
        if (res && res.TimeOutTime) {
          this.timeDown(res);
        } else {
          this.timeRes = res || {};
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    timeDown(content) {
      this.timer = setInterval(() => {
        const timeObj = getHMS(content.TimeOutTime);
        this.timeRes = { ...content, ...timeObj };
        if (timeObj.timeOut) {
          this.clearTimer();
        }
      }, 1000);
    },
    // 清除定时器
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.as-time-line-wrap {
  font-size: 14px;
  margin-bottom: 30px;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/aftersale/as-time-line.vue